<template>
  <div class="introduction">
    <div class="introduction-banner">
      <img src="@/assets/index/partyAllience/group-three.png" alt />
    </div>
    <div class="introduction-content">
      <div class="introduction-content-title">眉山市东坡区财富中心综合党委</div>
      <p>
        眉山财富中心大厦位于眉山市核心商务区，楼宇企业主要从事文旅研学、保险金融等行业。
        财富中心综合党委成立于2021年，覆盖企业党支部4个、企业24家、党员38名，致力于党建
        引领楼宇企业高质量发展，服务眉山发展大局。
      </p>
      <p>
        财富中心综合党委由楼宇标杆企业、社区、商圈、区域企业党组织组建形成，设书记1名，
        副书记2名，委员4名，形成紧密联系、多维互动的组织联建体系。</p>
      <p>以财富中心综合党委为核心建立“3+X”联席会议制度，定期召开年初部署、
        年中推进、年底总结3个会议，不定期召开区域治理等“X”系列主题交流会，
        搭建起社区与楼宇的沟通“桥梁”。
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang='scss' scoped>
.introduction {
  &-content {
    p{
      text-indent: .4rem;
      color: #333333;
      margin-bottom: .2rem;
    }
    &-title{
      font-weight:bold;
      font-size: .36rem;
      text-align: center;
      line-height: 3;
    }
    position: absolute;
    top: 3.5rem;
    width: 94%;
    left: 3%;
    background: #fff;
    box-shadow: 0px 0.08rem 0.24rem 0px rgba(0, 0, 0, 0.17);
    border-radius: 0.08rem;
    padding: 0.2rem;
    padding-bottom: .5rem;
  }
  &-banner {
    img {
      width: 100%;
    }
  }
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>